<template>
  <main>
    <slot></slot>
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "MainContainer",
  props: {},
})
</script>
<style scoped lang="scss">
main {
  min-height: calc(100vh - var(--header-height) - 16px);
  margin: 0px 16px 0 0;
  margin-left: calc(var(--left-aside-width) + 16px);
  padding-bottom: calc(
    100px + env(safe-area-inset-bottom) + 100vh - var(--vh) * 100
  );
  padding-top: calc(
    var(--header-height) + 32px + env(safe-area-inset-top, 16px)
  );
  box-sizing: border-box;
}
</style>
